module.exports = __webpack_public_path__ + "f75734658ebf8079a42fc65a27da9242.svg";